import * as React from 'react';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {Illustration} from 'shells/illustrations/illustration';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

import {useGetAudienceDashboard} from '../graphql/hooks';
import {ViewAllLink} from '../view-all-link';

import {AudiencesTable} from './audiences-table';

type Props = {
    timespan: string;
};

export function AudiencesCard(props: Props) {
    const {audienceDashboard, isLoading} = useGetAudienceDashboard({timespan: props.timespan});
    const totalCount = audienceDashboard ? audienceDashboard.totalCount : undefined;

    const tableData = audienceDashboard
        ? audienceDashboard.audiences.map((audienceInfo) => ({
              id: audienceInfo.audience.id,
              name: audienceInfo.audience.name,
              htmlUrlPath: audienceInfo.audience.htmlUrlPath,
              total: audienceInfo.formattedTotal,
          }))
        : [];

    return (
        <DashboardCard
            title='Audiences'
            subtitle='Targeted lists of contacts for your email outreach'
            link={<ViewAllLink totalCount={totalCount} type='AUDIENCE' />}
            isLoading={isLoading}
            mainContent={{content: <AudiencesTable tableData={tableData} />}}
            promoStateOverlay={
                totalCount === 0 ? (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: true,
                            imageComponent: (
                                <Illustration src='trial-onboarding/marketing-audiences' />
                            ),
                            title: 'Audiences receive outreach',
                            subtitle:
                                'Tailor your outreach to the right people by creating unique audiences for different messages.',
                            primaryCta: {
                                text: 'Learn more',
                                url: 'https://support.nutshell.com/en/articles/8428866-audiences-how-to-create-marketing-audiences',
                                isExternalLink: true,
                            },
                            secondaryCta: {
                                text: 'Create an audience',
                                url: '/email-marketing/audiences?sort=-modifiedTime',
                            },
                            alignBottom: true,
                            blueImageBackground: true,
                        }}
                    />
                ) : null
            }
        />
    );
}
